module.exports = __webpack_public_path__ + "static/media/vail-1.00f34a1a.jpg";